<template>
  <el-submenu
    :popper-append-to-body="false"
    popper-class="sub-menu-list"
    :index="menu.path"
  >
    <template slot="title">{{ menu.name }}</template>
    <template v-for="(sub, index) in menu.submenu">
      <template v-if="sub.submenu">
        <!-- vue循环嵌套组件 -->
        <OEMSubMenu :index="sub.path" :menu="sub" :key="sub.name + index" />
      </template>
      <el-menu-item :index="sub.path" v-else :key="sub.name + index">{{
        sub.name
      }}</el-menu-item>
    </template>
  </el-submenu>
</template>

<script>
export default {
  name: "OEMSubMenu",
  props: {
    menu: {
      type: Object,
      default: () => {
        return {};
      },
    },
    index: {
      type: String,
      default: "",
    },
  },
  created() {
    console.log("开始渲染menu子节点：", this.menu);
  },
  methods: {},
};
</script>

<style>
.el-submenu__title {
  width: 120px;
  /* height: 52px !important;
  line-height: 52px !important; */
}
.el-menu--popup .el-menu-item:hover {
  background-color: #fff !important;
}
.el-menu--popup .el-menu-item {
  background-color: #fff !important;
}
.el-submenu__title:hover {
  background-color: transparent !important;
}
.el-submenu:hover {
  background-color: transparent !important;
}
/* .el-menu--popup {
  color: #000;
} */
.menu-list .el-menu-item:hover {
  background-color: transparent !important;
  /* color: #fff !important; */
}
</style>
